import { IStep } from '..'

const Step = ({ image, title, subtitle }: IStep) => {

  return (
    <div className="onboarding-steps__step">
      {image && <img src={image} alt="" className="onboarding-steps__step__img" />}
      <h3 className="onboarding-steps__step__title">{title}</h3>
      <p className="onboarding-steps__step__description">{subtitle}</p>
    </div>
  )
}

export default Step
